/**
 * EForm Instance PDF 匯出設定
 * 含「縮放以塞進一頁」(fit to page) 開關。
 */

import React from 'react';
import { Modal, Typography, Button, Switch, Space } from 'antd';
import { useLanguage } from '../../../../contexts/LanguageContext';

const { Paragraph } = Typography;

const EFormInstanceSettings = ({ open, onClose, fitToPage = false, onFitToPageChange }) => {
  const { t } = useLanguage();

  return (
    <Modal
      title={t('reports.eformInstancePdfSettings') || 'PDF 匯出設定'}
      open={open}
      onCancel={onClose}
      footer={[<Button type="primary" key="ok" onClick={onClose}>{t('common.confirm') || '確定'}</Button>]}
      width={480}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          {t('reports.eformInstancePdfSettingsDescription') ||
            '版面依表單 HTML/CSS 與預設邊距。'}
        </Paragraph>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>{t('reports.eformInstancePdfFitToPage') || '縮放以塞進一頁 (Fit to page)'}</span>
          <Switch
            checked={fitToPage}
            onChange={onFitToPageChange}
            checkedChildren={t('common.on') || '開'}
            unCheckedChildren={t('common.off') || '關'}
          />
        </div>
        <Paragraph type="secondary" style={{ marginBottom: 0, fontSize: '12px' }}>
          {t('reports.eformInstancePdfFitToPageDescription') ||
            '開啟時，每個表單會縮放以塞進一頁 PDF。（Fit to one page）'}
        </Paragraph>
      </Space>
    </Modal>
  );
};

export default EFormInstanceSettings;
